export function clearLinkingError(field) {
    return {
        type: 'CLEAR_ACCOUNT_LINKING_ERROR',
        field
    };
}

export function clearLinkingErrors() {
    return {
        type: 'CLEAR_ACCOUNT_LINKING_FIELDS'
    };
}

export function linkAccount(data) {
    return {
        type: 'ACCOUNT_LINKING_REQUESTED',
        data
    };
}

export function selectStep(selectedStep) {
    return {
        type: 'SELECT_STEP',
        selectedStep: selectedStep
    };
}

export function nextStep(nextStepId) {
    return {
        type: 'NEXT_STEP',
        nextStepId
    };
}

export function toggleManualAddress(personUID, addressIndex) {
    const path = `${personUID}.${addressIndex}`;
    return {
        type: 'TOGGLE_MANUAL_ADDRESS',
        path
    };
}

export function removePersonManualAddressState(personUID) {
    return {
        type: 'REMOVE_PERSON_MANUAL_ADDRESS_STATE',
        personUID
    };
}

export function toggleCountryModal() {
    return {
        type: 'TOGGLE_COUNTRY_MODAL'
    };
}

export function toggleManualCompanyName() {
    return {
        type: 'TOGGLE_MANUAL_COMPANY_NAME'
    };
}

export function updateStepData(step) {
    return {
        type: 'UPDATE_STEP_DATA',
        step
    };
}

export function toggleLoadState() {
    return {
        type: 'TOGGLE_LOAD_STATE'
    };
}

export function rejectFile(file, errorMessage) {
    return {
        type: 'REJECT_FILE',
        payload: {
            file,
            errorMessage
        }
    };
}

export function updatePostStatus(id, status) {
    return {
        type: 'POST_STATUS_UPDATE',
        data: {
            id,
            status
        }
    };
}

export function saveCustomerState(state) {
    return {
        type: 'SAVE_CUSTOMER_STATE_REQUESTED',
        state
    };
}

export function disableBusinessIncome(disabled) {
    return {
        type: 'TOGGLE_NON_BUSINESS_INCOME',
        disabled
    };
}

export function disableMonthlyOtherHouseholdIncome(disabled) {
    return {
        type: 'TOGGLE_NON_MONTHLY_OTHER_HOUSEHOLD_INCOME',
        disabled
    };
}

export function clearFetchedCompaniesList(visibility) {
    return {
        type: 'CLEAR_FETCHED_COMPANIES_LIST',
        visibility
    };
}

export function fetchCompanies(companyName) {
    return {
        type: 'COMPANIES_FETCH_REQUESTED',
        companyName
    };
}
